import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import * as salesCoachingActions from 'action/salesCoaching'
import * as reportActions from 'action/report'
import { bindActionCreators } from 'redux'
import ContentHeader from 'component/utils/ContentHeader'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Breadcrumb from 'component/Breadcrumb'
import AccomplishedCoachesView from 'component/salesCoaching/AccomplishedCoachesView'
import SalesCoachingFilterForm from 'component/salesCoaching/ReportFilter'

class SalesCoachingContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    count: PropTypes.number,
    fetchReports: PropTypes.func.isRequired,
    countSalesCoaching: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.handleCountSalesCoaching({ idBranches: [] })
  }

  handleCountSalesCoaching = (filters) => {
    const {
      auth: { user },
      countSalesCoaching,
    } = this.props

    countSalesCoaching(user.dsToken, filters)
  }

  handleFetchReport = (filters) => {
    const {
      fetchReports,
      auth: { user },
    } = this.props

    const values = {
      tpReport: 8,
    }

    fetchReports(user.dsToken, values, filters)
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('mobile.reports') },
      { title: translate('mobile.salesCoaching') },
    ]

    return <Breadcrumb steps={steps} />
  }

  render() {
    const { translate, auth, count } = this.props

    return (
      <section>
        <ContentHeader>{translate('mobile.salesCoaching')}</ContentHeader>

        {this.renderBreadcrumb()}

        <Row className='container-mobile container-flex sales-coaching'>
          <Col xs={12} sm={12} md={6} lg={4} lgOffset={4}>
            <div className='rectangle border rounded color-default'>
              <AccomplishedCoachesView
                user={auth.user}
                translate={translate}
                count={count}
                title={translate('salesCoaching.accomplishedCoaches')}
                countSalesCoaching={this.handleCountSalesCoaching}
              />
            </div>
          </Col>
        </Row>

        <Row className='container-mobile container-flex'>
          <Col xs={12} sm={12} md={6} lg={4} lgOffset={4}>
            <SalesCoachingFilterForm
              translate={translate}
              fetchReports={this.handleFetchReport}
              user={auth.user}
            />
          </Col>
        </Row>
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
/* istanbul ignore next */
const mapStateToProps = ({ salesCoachingReducer, reportReducer }) => ({
  count: salesCoachingReducer.get.count,
  report: reportReducer.get.record,
})

/*
 * Maps actions and dispatch them to component props
 */
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...salesCoachingActions, ...reportActions }, dispatch)

/*
 * Connects component to I18next
 */
const SalesCoachingTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(SalesCoachingContainer)

/*
 * Exports component connected to redux as default
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesCoachingTranslated)

/*
 * Exports as component
 */
export { SalesCoachingContainer as SalesCoaching }
